module.exports = __webpack_public_path__ + "static/img/banner2.b5b4533.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/banner2.png
// module id = u21S
// module chunks = 44